<div *ngIf="!loading">
  <p-timeline
    *ngIf="isUserAdmin() && !showError"
    [value]="events"
    align="alternate"
    styleClass="customized-timeline"
  >
    <ng-template pTemplate="marker" let-event>
      <span
        class="custom-marker shadow-2"
        [style.backgroundColor]="event.color"
      >
        <i [ngClass]="event.icon"></i>
      </span>
    </ng-template>
    <ng-template pTemplate="content" let-event>
      <!-- [subheader]="event.date" -->
      <p-card>
        <ng-template pTemplate="header">
          <div
            class="m-2 p-card-title flex align-items-center justify-content-start"
            [ngClass]="{
              'justify-content-end': isMultiploDeDois(event.index)
            }"
          >
            {{ event.status }}
            <button
              *ngIf="event.link.length > 1"
              pButton
              pRipple
              icon="pi pi-fw pi-eye"
              rounded
              small
              text
              pTooltip="Progresso dos sub-passos"
              [matMenuTriggerFor]="menuSubPassos"
            ></button>
            <mat-menu #menuSubPassos="matMenu">
              <div class="flex flex-column justify-content-center width-100">
                <span
                  class="font-light text-center"
                  *ngFor="let subStep of event.link"
                >
                  {{ subStep.titulo }}
                  <i
                    [class]="
                      subStep.concluido
                        ? 'pi pi-fw pi-check text-green-500'
                        : 'pi pi-fw pi-times-circle text-red-500'
                    "
                  ></i>
                </span>
              </div>
            </mat-menu>
          </div>
        </ng-template>
        <img
          *ngIf="event.image"
          [src]="event.image"
          [alt]="event.name"
          width="200"
          class="shadow-2 mb-2"
          style="border-radius: 10px;"
        />
        <p>{{ event.description }}</p>
        <div
          [matTooltip]="
            !disabledButton(event.flag) || event.finish ? '' : event.toolTip
          "
        >
          <!-- event.toolTip -->
          <button
            pButton
            pRipple
            [icon]="
              disabledButton(event.flag)
                ? 'pi pi-spin pi-clock'
                : 'pi pi-fw pi-pencil'
            "
            [label]="
              disabledButton(event.flag)
                ? 'Preencha o passo anterior'
                : 'Inserir informações'
            "
            iconPos="right"
            *ngIf="!event.finish"
            class="p-button-outlined p-button-rounded mt-2 cursor-pointer"
            [disabled]="disabledButton(event.flag)"
            (click)="sendTo(event.link)"
          ></button>
          <div class="" *ngIf="event.finish">
            <button
              pButton
              pRipple
              [icon]="
                event.link.length > 1 && checkSubPassosConcluiu(event.link)
                  ? 'pi pi-fw pi-thumbs-up'
                  : 'pi pi-fw pi-pencil'
              "
              [label]="
                event.link.length > 1 && checkSubPassosConcluiu(event.link)
                  ? 'Já concluiu todos os passos!'
                  : 'Editar informações'
              "
              iconPos="right"
              (click)="
                event.link.length > 1 && checkSubPassosConcluiu(event.link)
                  ? null
                  : sendTo(event.link)
              "
              class="p-button-outlined p-button-rounded mt-2 p-button-primary"
            ></button>
            <i
              class="pi pi-fw pi-check-circle mb-3 ml-2 cursor-pointer"
              style="color: green;"
              pTooltip="Passo finalizado!"
            ></i>
          </div>
        </div>
      </p-card>
    </ng-template>
  </p-timeline>
  <viggo-core-accessdenied
    *ngIf="!isUserAdmin() && !showError"
    title="ACESSO NEGADO"
    [srcImg]="'./assets/images/access_denied.svg'"
    [classImg]="'content-img'"
    message="Contacte o administrador para finalizar os passos iniciais que irão
    liberar o acessar ao sistema."
  ></viggo-core-accessdenied>
  <viggo-core-error
    *ngIf="showError"
    [title]="errorObj.title"
    [noBackground]="true"
    [srcImg]="errorObj.srcImg"
    [classImg]="errorObj.classImg"
    [message]="errorObj.message"
  ></viggo-core-error>
</div>
